import React from "react";

import Label from "../Label/Label";
import { SelectProps } from "./Select.types";
import "./Select.scss";
import ErrorMessage from "../ErrorMessage/ErrorMessage";

const Select = ({
  options,
  selectedIndex,
  onChange,
  valid = false,
  disabled = false,
  prompt = "select...",
  id,
  label,
  errorMessage,
}: SelectProps) => (
  <div data-testid="Select" className="mp-atoms-select--main">
    {label && <Label htmlFor={id}>{label}</Label>}
    {options && (
      <select
        id={id}
        className={valid ? "valid" : ""}
        value={selectedIndex > -1 ? selectedIndex : -1}
        onChange={(event) => {
          onChange(parseInt(event.target.value));
        }}
        disabled={disabled}
      >
        <option value={-1} disabled>
          {prompt}
        </option>

        {options.map((option, index) => {
          return (
            <option key={`select-option-${index}`} value={index}>
              {option.label}
            </option>
          );
        })}
      </select>
    )}
    {errorMessage && <ErrorMessage errorMessage={errorMessage} errorId={id} />}
  </div>
);

export default Select;
